import { defineMessages } from 'react-intl';

const messages = {
  name: {
    id: 'ORGANIZATION_INFO.name',
    defaultMessage: 'Name',
  },
  company: {
    id: 'ORGANIZATION_INFO.company',
    defaultMessage: 'Company',
  },
  country: {
    id: 'ORGANIZATION_INFO.country',
    defaultMessage: 'Country',
  },
  language: {
    id: 'ORGANIZATION_INFO.language',
    defaultMessage: 'Language',
  },
  connectionStatus: {
    id: 'ORGANIZATION_INFO.connectionStatus',
    defaultMessage: 'Connection status',
  },
  companyAnalyst: {
    id: 'ORGANIZATION_INFO.companyAnalyst',
    defaultMessage: 'Analyst',
  },
  companyRules: {
    id: 'ORGANIZATION_INFO.companyRules',
    defaultMessage: 'Company rules',
  },
};

export default defineMessages(messages);



// WEBPACK FOOTER //
// ./components/molecules/Company/messages.js